import { Injectable } from "@angular/core";
import { MenuData } from "@xanadu/menu";
import { DragDrop, NodeModel, RegistryEntry, Document } from "@xanadu/model";
import { TabSignalSet } from "./tab-signal-set";

@Injectable({
    providedIn: 'root'
})
export class TabSignal {
    readonly delete = new TabSignalSet<NodeModel>();
    readonly drop = new TabSignalSet<DragDrop>();
    readonly load = new TabSignalSet<NodeModel>();
    readonly enter = new TabSignalSet<RegistryEntry>();
    readonly erase = new TabSignalSet<string>();
    readonly menu = new TabSignalSet<MenuData>();
    readonly node = new TabSignalSet<NodeModel>();
    readonly replace = new TabSignalSet<NodeModel>();
    readonly reset = new TabSignalSet<Document>();
    readonly seek = new TabSignalSet<string[]>();
    readonly path = new TabSignalSet<any>();
}
